import { Component, Input } from '@angular/core';
import { YCModalComponent } from '@yourcause/common/modals';

@Component({
    selector: 'gc-no-programs-available-modal',
    templateUrl: './no-programs-available-modal.component.html',
    styleUrls: ['./no-programs-available-modal.component.scss'],
    standalone: false
})
export class NoProgramsAvailableModalComponent extends YCModalComponent<boolean> {
  @Input() failMessage: string;

}
